import { useEffect, useState } from "react";
import { loadPurchaseReceivedList } from "../services/purchaseIndentService";

const usePurchaseReceivedList = (mode) => {
    const [dataLoad, setDataLoad] = useState(false);
    const [receivedData, setReceivedData] = useState([]);

    const loadData = async () => {
        try {
            const payload = {
                p_companyid: 1,
                p_mode: mode,
            };

            const data = await loadPurchaseReceivedList(payload);
            setReceivedData(Array.isArray(data) ? data : []);
        } catch (error) {
            console.error("Error loading received list:", error);
            setReceivedData([]);
        } finally {
            setDataLoad(true);
        }
    };

    useEffect(() => {
        if (!dataLoad) {
            loadData();
        }
    }, [dataLoad, mode]); // Depend on mode in case it changes

    const refreshReceivedListSummary = () => {
        setDataLoad(false); // Will re-trigger useEffect
    };

    return {
        receivedData,
        setReceivedData,
        refreshReceivedListSummary,
    };
};

export default usePurchaseReceivedList;
